import { parsePhoneNumber } from './phone-number.parser';

export const formatPhoneNumberForInput = (phone: string): string => {
  return parsePhoneNumber(phone).formattedForInput;
};

export const formatPhoneNumberInternational = (phone: string) => {
  return parsePhoneNumber(phone).formattedInternationalPlain;
};

// If US phone number - returns "national format" else returns "international formats"
export const formatPhoneNumberNationalForUS = (phone: string) => {
  const { country, formattedNational, formattedInternationalPlain } = parsePhoneNumber(phone);

  return country === 'US' ? formattedNational : formattedInternationalPlain;
};

export const formatPhoneNumberToE164 = (phone: string): string => {
  return parsePhoneNumber(phone).e164;
};
